import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddNewReceipts from "../../pages/PrimeFigma/NewReceiptVoucherv2";

const style = {
  position: "absolute",
  left: "5%",
  right: "5%",
  // transform: 'translate(-50%, -50%)',
  bgcolor: "background.paper",
  boxShadow: 24,
  paddingBottom: 2,
  outline: "none",
  // overflow: "scroll",
  height: "93vh",
};
function AddBalanceSheetReceipt({
  open,
  setOpen,
  groupName,
  accountDetails,
  onSaveComplete,
}) {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      localStorage.removeItem("modalOpen")
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Receipts
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{ overflow: "scroll", height: "80vh", padding:"10px" }}
          >
            {accountDetails?.accountsid && accountDetails?.label && (
              <AddNewReceipts
                method={accountDetails?.type}
                receivedFrom={
                  accountDetails?.type === undefined
                    ? {
                        label: accountDetails?.label,
                        value: accountDetails?.accountsid,
                        AccountTypeFlag: accountDetails?.accounttypeflag,
                      }
                    : null
                }
                receivedTo={
                  accountDetails?.type !== undefined
                    ? {
                        label: accountDetails?.label,
                        value: accountDetails?.accountsid,
                        AccountTypeFlag: accountDetails?.accounttypeflag,
                      }
                    : null
                }
                onSaveComplete={onSaveComplete}
              />
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddBalanceSheetReceipt;
